import React from 'react';
import './FormGrid.css';

const FormGrid = ({
  children,
  columns = 2,
  gap = '16px',
  className = '',
  responsive = true
}) => {
  const gridStyles = {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: gap,
    width: '100%'
  };

  const gridClassName = `form-grid ${responsive ? 'responsive' : ''} ${className}`.trim();

  return (
    <div className={gridClassName} style={gridStyles}>
      {children}
    </div>
  );
};

// Componente para campos que ocupan toda la fila
export const FormGridFullWidth = ({ children, className = '' }) => {
  return (
    <div className={`form-grid-full-width ${className}`}>
      {children}
    </div>
  );
};

// Componente para agrupar campos relacionados
export const FormGridSection = ({ title, children, className = '' }) => {
  return (
    <div className={`form-grid-section ${className}`}>
      {title && <h3 className="form-grid-section-title">{title}</h3>}
      <div className="form-grid-section-content">
        {children}
      </div>
    </div>
  );
};

export default FormGrid;